import { createFileRoute } from '@tanstack/react-router'

import PageWorkflowAssets from '../pages/PageWorkflowAssets'

export const Route = createFileRoute('/workflow/$workflowId/assets')({
  component: PageWorkflowAssets
})
